export default __webpack_public_path__ + "static/media/link.b6a11bbe.png";